export default function WarningIcon({ className = '', size = '20' }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M8.34084 6.8623H10.3408V11.8623H8.34084V6.8623ZM8.33984 12.8623H10.3398V14.8623H8.33984V12.8623Z"
        fill="currentColor"
      />
      <path
        d="M11.1088 1.062C10.7608 0.407 10.0828 0 9.34077 0C8.59877 0 7.92077 0.407 7.57277 1.063L0.234769 14.926C0.0719372 15.2304 -0.00872219 15.5721 0.000747357 15.9172C0.0102169 16.2623 0.109488 16.599 0.288769 16.894C0.465468 17.1904 0.716409 17.4356 1.01682 17.6053C1.31723 17.7751 1.65672 17.8635 2.00177 17.862H16.6798C17.3878 17.862 18.0288 17.5 18.3938 16.894C18.5728 16.5989 18.6719 16.2622 18.6813 15.9171C18.6908 15.5721 18.6103 15.2305 18.4478 14.926L11.1088 1.062ZM2.00177 15.862L9.34077 1.999L16.6848 15.862H2.00177Z"
        fill="currentColor"
      />
    </svg>
  );
}
